<div class="overview-item">
  <span class="title">{{ 'STATISTICS.NEXT_MONTH_RENT_HEADER' | translate }}</span>
  <div class="d-flex align-items-center">
    <div class="w-100">
      <span class="amount-value">{{ rent | money: true : null : rent.currencyCode }}</span>
    </div>
  </div>
</div>
